module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Cart2-24e04afc623ff35874d8770eb7b0e2c7.svg";